import React from 'react';
import PropTypes from 'prop-types';
import { sizes } from 'reactive-container';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { ServiceRequestCard } from 'components/ServiceRequestDisplayElement';

import { CardWrapper } from 'elements/Card';

export function ServiceRequestDisplayContainer({
  datum,
  type,
}) {
  switch (type) {
    case 'list':
      return (
        null
      );
    case 'card':
    default:
      return (
        <CardWrapper
          responsiveModifiers={{
            [sizes.XS]: ['1_per_row'],
            [sizes.SM]: ['2_per_row'],
            [sizes.MD]: ['3_per_row'],
            [sizes.LG]: ['4_per_row'],
            [sizes.XL]: ['5_per_row'],
          }}
        >
          <ServiceRequestCard
            serviceRequestInfo={datum}
          />
        </CardWrapper>
      );
  }
}

ServiceRequestDisplayContainer.propTypes = {
  datum: ImmutablePropTypes.contains({
    id: PropTypes.string,
  }).isRequired,
  type: PropTypes.oneOf(['card', 'list', 'map']).isRequired,
};

ServiceRequestDisplayContainer.defaultProps = {
  selectedServiceRequestId: '',
};

export default ServiceRequestDisplayContainer;



// WEBPACK FOOTER //
// ./containers/ServiceRequestDisplayContainer/index.js